import script from "./WeChatContactWindow.vue?vue&type=script&lang=ts&setup=true"
export * from "./WeChatContactWindow.vue?vue&type=script&lang=ts&setup=true"

import "./WeChatContactWindow.vue?vue&type=style&index=0&id=17bb2676&lang=css"
import "./WeChatContactWindow.vue?vue&type=style&index=1&id=17bb2676&scoped=true&lang=css"

import exportComponent from "/Users/ra1to/Desktop/web_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17bb2676"]])

export default __exports__